import React, { useState, useEffect } from 'react'; 
import axios from 'axios';

import Stack from '@mui/joy/Stack';
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import Alert from '@mui/joy/Alert';
import Divider from '@mui/joy/Divider';
import FormControl from '@mui/joy/FormControl';
import FormHelperText from '@mui/joy/FormHelperText';
import Input from '@mui/joy/Input';
import Select from '@mui/joy/Select';
import Switch from '@mui/joy/Switch';
import Option from '@mui/joy/Option';
import Typography from '@mui/joy/Typography';
import Avatar from '@mui/joy/Avatar';
import CircularProgress from '@mui/joy/CircularProgress';
import IconButton from '@mui/joy/IconButton';

// Icons
import IcoMail from '@mui/icons-material/Mail';
import IcoGlobe from '@mui/icons-material/Language';
import IcoMobile from '@mui/icons-material/PhoneIphone';
import IcoNo from '@mui/icons-material/CancelOutlined';
import IcoCheck from '@mui/icons-material/CheckCircleOutline';

import useDebounce from "./useDebounce.js";
import {config} from "./config.js";

export default function Profile() {
	const [loading, setLoading] = useState(true);
	const [errorMsg, setErrorMsg] = React.useState("");	
	const [user, setUser] = useState({
		userID: "",
		email: "",
		mobile: "",
		locale: "sv-SE",
		useEmail: false,
		useMobile: false
	});
	const userid = localStorage.getItem("username");
	const [validEmail, setValidEmail] = useState(false);
	const [validMobile, setValidMobile] = useState(false);
	const [mailCheck, setMailCheck] = useState(false);
	const [mobileCheck, setMobileCheck] = useState(false);	
	
	
	function isEmailValid(m) {
		let regex = new RegExp(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/);
	
		return regex.test(m);	
	}
	
				
	const debouncedRequest = useDebounce(() => {
		var url = config.IP + "/saveuser";

		console.log("Sparar user", user);	

		axios.post(url, user).then((response) => {

			// We must have a valid adress to be able to logout (and login)
			if (validEmail || validMobile)
				localStorage.setItem("usercreated", true);
			else
				localStorage.setItem("usercreated", false);

			console.log("respons=", response);
		});

	});
	

	useEffect(() => {		

		const getUser = async () => {
			var url = config.IP + "/user/" + userid;
			console.log("useEffect: Hämtar user:", userid);
			setLoading(true);
			
			try {
				await axios.get(url)
					.then((res) => {
						setUser({
							userID:    userid,
							email:     res.data[0].email,
							mobile:    res.data[0].mobile,
							locale:    res.data[0].locale,
							useEmail:  res.data[0].useEmail,
							useMobile: res.data[0].useMobile
						});
						
						setValidEmail(res.data[0].email);
						setMailCheck(res.data[0].useEmail);
						
						setValidMobile(res.data[0].mobile);
						setMobileCheck(res.data[0].useMobile);
						
						setErrorMsg("");
						
					});
			} catch (error) {
				if (error.response) {				
					if (error.response.status == 404) {
						// User not found, create empty user and save
						console.log("User not found, create new");					
						url = config.IP + "/saveuser";				
						var user = {
							userID: userid,
							email: "",
							mobile: "",
							locale: "sv-SE",
							useEmail: false,
							useMobile: false						
						}
						
						setUser(user);				
						
						axios.post(url, user).then((response) => {
							console.log("New user created and saved=", response);
						});					
					}
					else {
						setErrorMsg("Server Error: " + error.response.status);
						console.error("ERROR:getUser:servererror", error.response.status);					
					}
				} else if (error.request) {
					setErrorMsg("Network Error: " + error.code);					
					console.error('Network Error:', error.code);
				} else {
					setErrorMsg("Error: " + error.message);					
					console.error('Error:', error.message);
				}						
			}
			
			setLoading(false);			
		}
		
		getUser();
				
	}, []);
	
	
	const onEmailChange = e => {
		const value = e.target.value.trim();
		
		setValidEmail(isEmailValid(value));

		setUser({
			...user,
			email: value
		});
	    debouncedRequest();
	};	


	const onUseEmailChange = e => {
		const value = e.target.checked;

		setMailCheck(value);
		
		setUser({
			...user,
			useEmail: value
		});		
	    debouncedRequest();
	};	


	const onMobileChange = e => {
		const value = e.target.value.trim();

		setValidMobile(value.length > 3);

		setUser({
			...user,
			mobile: value
		});
	    debouncedRequest();
	}


	const onUseMobileChange = e => {
		const value = e.target.checked;

		setMobileCheck(value);
				
		setUser({
			...user,
			useMobile: value
		});		
	    debouncedRequest();	    
	}

	
	const onLocaleChange = (e, v) => {
		setUser({
			...user,
			locale: v
		});		
		localStorage.setItem("locale", v);
	    debouncedRequest();
	};	
	
	function handleMailClick() {
		console.log("Click mail");	
	}

	function handleMobileClick() {
		console.log("Click mobile");	
	}
	
	
	function getLoginIcon() {
		if (validEmail)
			return <IcoCheck color="success"/>;
		else
			return <IcoNo color="danger"/>;					
	}

	function getNotifyEmailIcon() {
		if (validEmail && mailCheck)
			return <IcoCheck color="success"/>;
		else
			return <IcoNo color="danger"/>;					
	}


	function getNotifyMobileIcon() {
		if (validMobile && mobileCheck)
			return <IcoCheck color="success"/>;
		else
			return <IcoNo color="danger"/>;					
	}

		
	return (
		<React.Fragment>
		{loading ? (
			<Stack direction="row" justifyContent="center">
				<CircularProgress variant="plain" size='lg'/>
			</Stack>			
		) : errorMsg == "" ? (
			<Card variant="outlined" sx={{maxHeight: 'max-content', maxWidth: '600px', mx: 'auto', resize: 'horizontal', bgcolor: config.cardColor}}>
			  	<CardContent sx={{gap: 1.5}}>
					<Typography component={'div'} level="title-lg" startDecorator={<Avatar color="success"/>}>
						Profile
				  	</Typography>

					<Typography>
						Enter email to be able to logout/login. Add (and check) mobile if you want to be notified by text messages.
				  	</Typography>


				  	<Divider inset="none" />
				  	
		  			<Input sx={{mb: -1}} endDecorator={<Switch checked={!!user.useEmail} onChange={onUseEmailChange}></Switch>} size="lg" value={user.email} type="email" autoFocus placeholder="my.mail@domain.com" onChange={onEmailChange} startDecorator={<IconButton variant="plain" onClick={handleMailClick}><IcoMail/></IconButton>}/>
		  			<FormHelperText sx={{alignSelf:'flex-end', color:'#51BC51'}}>(Free of charge)</FormHelperText>
					
					<Input sx={{mb: -1}} endDecorator={<Switch checked={!!user.useMobile} onChange={onUseMobileChange}></Switch>} size="lg" value={user.mobile} type="tel" placeholder="+(country code) your number" onChange={onMobileChange} startDecorator={<IconButton variant="plain" onClick={handleMobileClick}><IcoMobile /></IconButton>}/>
					<FormHelperText sx={{alignSelf:'flex-end', color:'#F09898'}}>($0.0578 per message)</FormHelperText>						

				  	<Divider sx={{mt:1}} inset="none" />
			        
			        <FormControl sx={{my:1}}>
						<Select size="lg" defaultValue={'se-SV'} value={user.locale} startDecorator={<IcoGlobe />} onChange={onLocaleChange}>
							<Option value="sv-SE">Sverige</Option>
							<Option value="en-US">United States</Option>
							<Option value="en-GB">United Kingdom</Option>
							<Option value="en-CA">Canada</Option>
						</Select>        
			        </FormControl>

				  	<Divider inset="none" />
				  	
					<Typography startDecorator={getLoginIcon()}>Able to logout/login</Typography>
					<Typography startDecorator={getNotifyEmailIcon()}>Stop notified by email</Typography>				  	
					<Typography startDecorator={getNotifyMobileIcon()}>Stop notified by mobile</Typography>
					<FormHelperText sx={{alignSelf:'flex-end', color: 'gray'}}>{config.version}</FormHelperText>
							        
				</CardContent>
		      
		    </Card>
		    
		) : <Stack direction="row" justifyContent="center" size="lg"><Alert color="danger" variant="solid">{errorMsg}</Alert></Stack> }
		
		</React.Fragment>		
	);
}